import { render, staticRenderFns } from "./collectInfoWindow.vue?vue&type=template&id=00465e04&scoped=true&"
import script from "./collectInfoWindow.vue?vue&type=script&lang=js&"
export * from "./collectInfoWindow.vue?vue&type=script&lang=js&"
import style0 from "./collectInfoWindow.vue?vue&type=style&index=0&id=00465e04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00465e04",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00465e04')) {
      api.createRecord('00465e04', component.options)
    } else {
      api.reload('00465e04', component.options)
    }
    module.hot.accept("./collectInfoWindow.vue?vue&type=template&id=00465e04&scoped=true&", function () {
      api.rerender('00465e04', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Clearing/components/DocumentCirculation/collectInfoWindow.vue"
export default component.exports